/** 2D helpers for the home page's drawings, in SVG coordinates (y down, degrees clockwise). */

/**
 * The point `r` from `center` at `deg` degrees.
 * @example
 * polar(10, 90); // [0, 10]
 * polar(5, 0, [100, 50]); // [105, 50]
 */
export const polar = (r: number, deg: number, center: [number, number] = [0, 0]): [number, number] => [
	center[0] + r * Math.cos((deg * Math.PI) / 180),
	center[1] + r * Math.sin((deg * Math.PI) / 180),
];

/**
 * The direction from `from` to `to`, in degrees.
 * @example
 * toward([0, 0], [0, 10]); // 90
 */
export const toward = (from: [number, number], to: [number, number]) => (Math.atan2(to[1] - from[1], to[0] - from[0]) * 180) / Math.PI;

/**
 * SVG path data for a polyline through `points`, rounded to `digits` decimals.
 * @example
 * polylinePath([{ x: 0, y: 0 }, { x: 10, y: 5 }]); // "M0.0 0.0L10.0 5.0"
 */
export const polylinePath = (points: { x: number; y: number }[], digits = 1) =>
	points.map((p, i) => `${i ? "L" : "M"}${p.x.toFixed(digits)} ${p.y.toFixed(digits)}`).join("");
